import { Banner } from '@/domain/types/collections';
import { Column } from '@/presentation/components/table';
import { MdCheckCircle, MdImage, MdLink } from 'react-icons/md';

export const columnsBanners: Column<Banner>[] = [
  {
    header: 'Preview',
    accessor: 'imageUrl',
    render: (value) => {
      const url = value as string;
      return url ? (
        <img
          src={url}
          alt="Banner preview"
          className="w-24 h-8 object-cover rounded border border-gray-300"
        />
      ) : (
        <div className="w-24 h-8 bg-gray-200 rounded flex items-center justify-center">
          <MdImage className="text-gray-400" />
        </div>
      );
    },
  },
  {
    header: 'Título ES / EN',
    accessor: 'title',
    render: (value, row) => {
      const title = value as string;
      const titleEN = (row as Banner).titleEN;
      return (
        <div className="flex flex-col gap-0.5">
          <span className="font-medium text-gray-800 line-clamp-1">
            <span className="inline-block text-xs font-bold bg-primary text-white px-1 rounded mr-1">
              ES
            </span>
            {title}
          </span>
          <span className="text-sm text-gray-500 line-clamp-1">
            <span className="inline-block text-xs font-bold bg-gray-600 text-white px-1 rounded mr-1">
              EN
            </span>
            {titleEN || <em className="text-primary/70">Sin Traducción</em>}
          </span>
        </div>
      );
    },
  },
  {
    header: 'Subtítulo',
    accessor: 'subtitle',
    render: (value) => {
      const subtitle = value as string | undefined;
      return subtitle ? (
        <span className="text-sm text-gray-700 line-clamp-1">{subtitle}</span>
      ) : (
        <span className="text-xs text-gray-400 italic">Sin subtítulo</span>
      );
    },
  },
  {
    header: 'Descripción',
    accessor: 'description',
    render: (value) => {
      const desc = value as string;
      return <span className="text-sm text-gray-600 line-clamp-2">{desc}</span>;
    },
  },
  {
    header: 'Estado',
    accessor: 'isActive',
    render: (value) => {
      const isActive = value as boolean;
      return (
        <span
          className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium ${
            isActive
              ? 'bg-green-100 text-green-700'
              : 'bg-gray-100 text-gray-700'
          }`}
        >
          {isActive && <MdCheckCircle />}
          {isActive ? 'Activo' : 'Inactivo'}
        </span>
      );
    },
  },
  {
    header: 'Adjuntos',
    accessor: 'attachments',
    render: (value) => {
      const attachments = value as Banner['attachments'];
      const count = attachments?.length || 0;
      return (
        <div className="flex items-center gap-1 text-gray-600">
          <MdLink size={18} />
          <span className="text-sm">{count}</span>
        </div>
      );
    },
  },
  {
    header: 'Orden',
    accessor: 'order',
    render: (value) => {
      const order = value as number;
      return order > 0 ? (
        <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-blue-100 text-blue-700 font-semibold text-sm">
          {order}
        </span>
      ) : (
        <span className="text-gray-400">-</span>
      );
    },
  },
  {
    header: 'Fecha',
    accessor: 'createdAt',
    render: (value) => {
      if (value && typeof value === 'object' && 'seconds' in value) {
        const date = new Date((value as { seconds: number }).seconds * 1000);
        return (
          <span className="text-sm">{date.toLocaleDateString('es-ES')}</span>
        );
      }
      return <span>-</span>;
    },
  },
];
